import { Add, Contracts, Diamond, Magnet } from "@dreamhub/designsystem/icons";
import { DropdownOptions } from "@/components/controls/Dropdown/Dropdown";
import { SingleSelectOptions } from "@/components/controls/Form/Form";
import IconContainer, { iconSize, IconColor } from "@/components/ui/icon-container";
import { ObjectEntity } from "@/entities/forms/types";
import { UserData } from "@/entities/users/types";
import { TFunction } from "i18next";
import { capitalize, forEach, keys, values } from "lodash";

const dropdownToSingleSelectOptions = (dropdownOptions?: DropdownOptions) => {
  if (!dropdownOptions) {
    return [];
  }
  const singleSelectOptions: SingleSelectOptions[] = [];
  forEach(keys(dropdownOptions), (id) => {
    const value = dropdownOptions[id];
    singleSelectOptions.push({
      id,
      displayName: value as string
    });
  });
  return singleSelectOptions;
};

const getUsersOptions = (
  users: Record<string, UserData>,
  loggedUserId?: string,
  t?: TFunction<"translation", undefined>
) => {
  const usersOptions: SingleSelectOptions[] = [];
  forEach(keys(users), (userId) => {
    const user = users[userId];
    usersOptions.push({
      id: userId,
      displayName:
        userId === loggedUserId && t ? capitalize(t("you")) : user.displayName
    });
  });
  return usersOptions;
};

const getLinkToOptions = (
  t: TFunction<"translation", undefined>,
  includeContract = true
) => {
  const linkToOptions: SingleSelectOptions[] = [];
  forEach(values(ObjectEntity), (objectId) => {
    if (objectId === ObjectEntity.CONTRACT && !includeContract) return;
    linkToOptions.push({
      id: objectId,
      displayName: t(`objectEntities.${objectId}`)
    });
  });
  return linkToOptions;
};

const renderObjectEntityIcon = (
  value: string | number | null,
  size?: iconSize,
  color?: IconColor
) => {
  let iconComponent = <Add />;
  if (value) {
    const objectEntityValue = value as ObjectEntity;
    iconComponent =
      objectEntityValue === ObjectEntity.DEAL ? (
        <Diamond />
      ) : objectEntityValue === ObjectEntity.CONTRACT ? (
        <Contracts />
      ) : (
        <Magnet />
      );
  }
  return (
    <IconContainer size={size} color={color}>
      {iconComponent}
    </IconContainer>
  );
};

export {
  dropdownToSingleSelectOptions,
  getUsersOptions,
  getLinkToOptions,
  renderObjectEntityIcon
};
